package com.schoolconnect.app.feature.schoolconfig

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun SchoolConfigFeatureRoute(
    roleLabel: String,
    roleSubtitle: String,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit,
    onBack: () -> Unit
) {
    val viewModel = remember { SchoolConfigViewModel() }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) { onDispose { viewModel.clear() } }

    SchoolConfigScreen(
        state = uiState,
        onEvent = viewModel::onEvent,
        roleLabel = roleLabel,
        roleSubtitle = roleSubtitle,
        onChangeRole = onChangeRole,
        onLogout = onLogout,
        onBack = onBack
    )
}
